class BrandStory extends HTMLElement {
  connectedCallback() {
    this.panels = Array.from(this.querySelectorAll('.brand-story__panel'));
    if (!this.panels.length) return;

    this.themeSlider = this.querySelector('theme-slider');
    this.mq = window.matchMedia('(min-width: 750px)');

    this.setActive(this.panels[0]);

    this.panels.forEach(panel => {
      panel.addEventListener('mouseenter', () => {
        if (this.mq.matches) this.setActive(panel);
      });
    });

    this.waitForSwiper(() => {
      this.handleBreakpoint();
      this.mq.addEventListener('change', () => this.handleBreakpoint());
    });
  }

  setActive(panel) {
    this.panels.forEach(p => p.classList.remove('is-active'));
    panel.classList.add('is-active');
  }

  waitForSwiper(callback) {
    if (this.themeSlider?.swiper) {
      callback();
      return;
    }
    const poll = setInterval(() => {
      if (this.themeSlider?.swiper) {
        clearInterval(poll);
        callback();
      }
    }, 50);
    setTimeout(() => clearInterval(poll), 3000);
  }

  handleBreakpoint() {
    const swiper = this.themeSlider?.swiper;
    if (!swiper) return;
    if (this.mq.matches) {
      swiper.disable();
    } else {
      swiper.enable();
    }
  }
}

customElements.define('brand-story', BrandStory);
